import { gql } from '@apollo/client'

// Add new booking
export const CREATE_BOOKING = gql`
    mutation CreateBooking($booking: BookingInput!, $bookingId: String) {
        createBooking(booking: $booking, booking_id: $bookingId) {
            code
            success
            message
            booking {
                booking_code
                booking_id
                trip_segments {
                    travel_date
                    passengers {
                        passenger {
                            medical_condition
                            medical_remarks
                        }
                    }
                }
                booking_type {
                    code
                    description {
                        en
                        ar
                    }
                }
            }
        }
    }
`

// Reschedule Booking
export const RESCHEDULING_BOOKING = gql`
    mutation ReschedulingBooking($booking: BookingInput!, $bookingId: NonEmptyString!) {
        reschedulingBooking(booking: $booking, booking_id: $bookingId) {
            code
            success
            message
            booking {
                booking_id
                total_price
                booking_code
                payment_channel
                payment_preference {
                    payment_channel
                    return_url
                    deduction {
                        use_wallet
                        promo_code
                    }
                }
                price {
                    final_price
                    total
                    payable
                    deduction {
                        wallet
                    }
                    price_summary {
                        price_type
                        type {
                            en
                            ar
                        }
                        unit_no
                        unit_price
                        total_price
                    }
                    price_summary_total
                }
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                trip_segments {
                    segment_id
                    travel_date
                    booking_id
                    route_id
                    trip_id
                    trip {
                        trip_id
                        trip_name {
                            en
                            ar
                        }
                        route_id
                        start_time
                        end_time
                    }
                    start {
                        location_id
                        stop_number
                        arrival_time
                        location {
                            id
                            name {
                                en
                                ar
                            }
                        }
                    }
                    end {
                        location_id
                        stop_number
                        arrival_time
                        location {
                            id
                            name {
                                en
                                ar
                            }
                        }
                    }
                    segment_order
                }
            }
        }
    }
`

// Make Payment
export const MAKE_BOOKING_PAYMENT = gql`
    mutation MakeBookingPayment(
        $bookingId: NonEmptyString!
        $travelDate: LocalDate!
        $forcedPayment: Boolean
        $payment: PaymentPreferenceInput!
    ) {
        makeBookingPayment(
            booking_id: $bookingId
            travel_date: $travelDate
            forced_payment: $forcedPayment
            payment: $payment
        ) {
            code
            success
            message
            payment_gateway {
                gateway
                session_id
                redirect_url
            }
        }
    }
`

// Day Pass Price
export const ADD_DAY_PASS_PRICE = gql`
    mutation AddBoatDayPassPrice($dayPassPrice: BoatDayPassPriceInput!) {
        addBoatDayPassPrice(day_pass_price: $dayPassPrice) {
            code
            success
            message
        }
    }
`

// Update Day Pass Price
export const UPDATE_DAY_PASS_PRICE = gql`
    mutation UpdateBoatDayPassPrice($dayPassPrice: BoatDayPassPriceInput!, $masterPriceId: NonEmptyString!) {
        updateBoatDayPassPrice(day_pass_price: $dayPassPrice, master_price_id: $masterPriceId) {
            code
            success
            message
        }
    }
`

// Cancel Booking
export const CANCEL_BOOKING = gql`
    mutation CancelBooking($tripIds: [NonEmptyString!], $cancellationType: CANCEL_TYPE!, $bookingId: NonEmptyString!) {
        cancelBooking(trip_ids: $tripIds, cancellation_type: $cancellationType, booking_id: $bookingId) {
            code
            success
            message
            booking {
                booking_id
                booking_code
                trip_segments {
                 trip_id
                    segment_id
                    segment_order
                    travel_date
                    passengers {
                        passenger_id
                        ticket_number
                        qr_code {
                            encrypted
                        }
                    }
                    start {
                        location_id
                        stop_number
                        arrival_time
                    }
                }
            }
        }
    }
`

// Sending ticket to email
export const SEND_TICKET_TO_EMAIL = gql`
    mutation SendBookingTicket($dispatch: BookingTicketDispatchInput!) {
        sendBookingTicket(dispatch: $dispatch) {
            code
            success
            message
        }
    }
`

// Add Booking Payment Details
export const ADD_BOOKING_PAYMENT_DETAILS = gql`
    mutation AddBookingPaymentDetails(
        $bookingId: NonEmptyString!
        $travelDate: LocalDate!
        $paymentInfo: BookingPaymentReceiptInput!
    ) {
        addBookingPaymentDetails(booking_id: $bookingId, travel_date: $travelDate, payment_info: $paymentInfo) {
            code
            success
            message
        }
    }
`
